import { render, staticRenderFns } from "./UpgradeSessionStatusTag.vue?vue&type=template&id=428cdf75&lang=pug"
import script from "./UpgradeSessionStatusTag.vue?vue&type=script&lang=js"
export * from "./UpgradeSessionStatusTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports